import { getItemDeliveryTypes, getItemErrors } from './DishUtils';
import moment from 'moment';
import { isItemDeletedFromMenu } from './MenuUtils';
import _ from 'lodash';

function isInvalidItem({ orderItem, menu, itemsHash, deliveryType }) {
  const item = itemsHash[orderItem.itemId];
  const itemDeliveryTypes = getItemDeliveryTypes(item);
  return (
    getItemErrors(item, moment()).length > 0 ||
    isItemDeletedFromMenu(orderItem.itemId, menu) ||
    !itemDeliveryTypes.includes(deliveryType)
  );
}

export function getUnavailableDishes({ orderItems, itemsHash, menu, deliveryType }) {
  const unavailable = [];
  orderItems.forEach(orderItem => {
    if (isInvalidItem({ orderItem, menu, itemsHash, deliveryType })) {
      unavailable.push({ orderItem, variations: [] });
      return;
    }

    const unavailableVariations = getUnavailableChosenVariations({ orderItem, menu, itemsHash, deliveryType });
    if (unavailableVariations.length > 0) {
      unavailable.push({ orderItem, variations: unavailableVariations });
    }
  });
  return unavailable;
}

function getUnavailableChosenVariations({ orderItem, menu, itemsHash, deliveryType }) {
  const variations = [];

  _.each(orderItem.variationsChoices, (variationsChoice, index) => {
    const availableVariations = _.get(itemsHash, `[${orderItem.itemId}].variations[${index}].itemIds`, []);
    const availableVariationIds = availableVariations.map(v => v.itemId);

    variationsChoice.forEach(variation => {
      if (
        isInvalidItem({ orderItem: variation, menu, itemsHash, deliveryType }) ||
        !availableVariationIds.includes(variation.itemId)
      ) {
        variations.push(variation.itemId);
      }
    });
  });

  return variations;
}

export function getFormattedTimeString(timestamp) {
  //todo masha use normal library
  const date = new Date(1000 * timestamp);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}`;
}
